// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"608":"858a1849","880":"cb5febd3"}[chunkId] + ".chunk.css";
};